import Vue from 'vue';
import Vuex from 'vuex';
import session from '@demre/client-common/src/components/jwt-refresher/session';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tiposPesd: {},
    usuario: {},
    modulos: {},
    proceso: {},
    anioProcesoAdmision: null,
  },
  mutations,
  getters,
  actions,
  modules: {
    session,
  }
});
